export const getBenefitPlanDataQueryKey = (planId: number) =>
  ['getBenefitPlanData', planId] as const;
